import { render, staticRenderFns } from "./AddExtractDispatchToRouteList.vue?vue&type=template&id=57d591ac&scoped=true&"
import script from "./AddExtractDispatchToRouteList.vue?vue&type=script&lang=js&"
export * from "./AddExtractDispatchToRouteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d591ac",
  null
  
)

export default component.exports